import { render, staticRenderFns } from "./iOSMonitorData.vue?vue&type=template&id=f308fef2&scoped=true"
import script from "./iOSMonitorData.vue?vue&type=script&lang=js"
export * from "./iOSMonitorData.vue?vue&type=script&lang=js"
import style0 from "./iOSMonitorData.vue?vue&type=style&index=0&id=f308fef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f308fef2",
  null
  
)

export default component.exports